<template>
  <!-- 客户选择，支持单选/多选，含分类树 -->
  <div class="customer-select">
    <div class="name el-select__prefix" @click="toShowDialog">
      <slot name="prefix"></slot>
    </div>
    <!-- 回显区：多选显示标签，单选显示名称，均可单独删除/清空 -->
    <div class="value" @click="toShowDialog">
      <template v-if="selectedItems.length">
        <div class="select-wrap">
          <div v-for="item in selectedItems" :key="item.id" :class="{'select-tag': multi}">
            <span class="tag-name">{{item.name}}</span>
            <yq-icon v-if="!disabled && multi" class="tag-close" name="element-ui_close" @click.stop="removeItem(item.id)"/>
          </div>
          <yq-icon v-if="!disabled" class="clear-all" name="element-ui_circle-close" @click.stop="clearData"/>
        </div>
      </template>
      <span v-else class="placeholder">{{placeholder}}</span>
    </div>
    <el-dialog v-model="showDialog" title="选择客户" dialog-width="3" :close-on-click-modal="false" append-to-body @opened="tableDataBack">
      <dialog-table>
        <separate-page :show-shadow="false" :show-border="true">
          <template #category>
            <tree-dictionary v-model:dictionary-list="customerCategoryTree" dictionary-type="CUSTOMER_CATEGORY" @clickCategory="clickCategory" :disabled="true"/>
          </template>
          <template #default>
            <list-page :show-shadow="false" :show-border="false">
              <search-condition :show-shadow="false" :show-border="false">
                <template #default>
                  <el-input v-model="dialogSearchInfo.searchKey" placeholder="请输入客户名称/手机号" @keydown.enter="resetSearchDialog">
                    <template #prefix>关键字</template>
                  </el-input>
                </template>
                <template #option>
                  <page-button type="read" el-type="primary" @click="resetSearchDialog">查询</page-button>
                </template>
              </search-condition>
              <table-list>
                <yq-table ref="selectTable" :data="dialogList" border :row-key="'id'" @selectionChange="dialogSelectionChange">
                  <yq-table-column v-if="multi" type="selection" width="60rem" align="center" fixed="left"/>
                  <yq-table-column label="客户名称" prop="merchantRemarkName" min-width="180rem"/>
                  <yq-table-column label="联系电话" prop="merchantRemarkPhone"/>
                  <yq-table-column label="客户类型" prop="contactType">
                    <template v-slot="{row}">
                      <el-tag v-if="row.contactType === 1">个人</el-tag>
                      <el-tag v-if="row.contactType === 0">公司</el-tag>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="地区" prop="merchantRegion">
                    <template v-slot="{row}">
                      <administrative v-model="row.merchantRegion" :disabled="true"/>
                    </template>
                  </yq-table-column>
                  <yq-table-column v-if="!multi" label="操作" align="center" width="60rem" fixed="right">
                    <template v-slot="{row}">
                      <table-button @click="selectCustomer(row)">选择</table-button>
                    </template>
                  </yq-table-column>
                </yq-table>
              </table-list>
              <form-page :show-shadow="false" :show-border="false" v-model:page-number="dialogSearchInfo.pageNumber" v-model:page-size="dialogSearchInfo.pageSize" :total-count="dialogSearchInfo.totalCount" @onLoad="dialogQueryList">
                <page-button @click="showDialog = false">取消</page-button>
                <page-button v-if="multi" type="read" el-type="primary" @click="confirmMulti">确定</page-button>
              </form-page>
            </list-page>
          </template>
        </separate-page>
      </dialog-table>
    </el-dialog>
  </div>
</template>

<script>


import {watch} from "vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import SeparatePage from "@/components/h5/layout/SeparatorPage.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableList from "@/components/h5/layout/ListTable.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import Administrative from "@/components/h5/data/Administrative.vue";
import commonDataApi from "@/api/normal/common/commonDataApi";
import YqIcon from "@/components/YqIcon.vue";
// 选择一个客户，用于表单或查询条件，支持单选/多选
export default {
  name: "CustomerSelect",
  emits: ["change", "update:modelValue"],
  props: {
    modelValue: {
      type: [String, Array],
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择客户"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否多选
    multi: {
      type: Boolean,
      default: false
    },
    queryApi: {default: null},
  },
  components: {
    YqIcon,
    Administrative,
    TreeDictionary, FormItems, FormItem,
    TableButton, DialogTable, PageButton, TableList, FormPage, SeparatePage, YqTableColumn, ListPage, SearchCondition
  },
  data() {
    return {
      customerName: "",
      value: "",
      showDialog: false,
      dialogSearchInfo: {partnerType: 1},
      dialogList: [],
      dialogSelected: [],
      customerCategoryTree: [],
      selectedItems: [], // 回显的已选客户 [{id: partnerId, name: merchantRemarkName}]
      isSelectData: false, // 是在前端选择的数据
    };
  },
  created() {
    this.init();
    watch(() => this.modelValue, () => {
      this.init()
    });
  },
  methods: {
    // 当前选中的 id 列表
    currentIds() {
      if (!this.modelValue) return [];
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.filter(Boolean);
      }
      return String(this.modelValue).split(',').filter(Boolean);
    },
    init() {
      const ids = this.currentIds();
      if (this.value === JSON.stringify(ids)) {
        return;
      }
      this.value = JSON.stringify(ids);
      if (ids.length === 0) {
        this.selectedItems = [];
        this.customerName = "";
        return;
      }
      if (this.isSelectData) {// 是在前端选择的数据
        return;
      }
      // 按当前 id 重新查名称回显。
      // ★ 必须整体覆盖 selectedItems，不能往上 append：
      // 同一个弹框里先看客户A再改看客户B时，append 会把 A 留在回显里，
      // 表现为「表单的客户栏同时出现两个客户」
      const idsKey = this.value;
      commonDataApi.queryPartnerBaseInfoByIds(ids).then(res => {
        // 响应回来时可能已经切到别的客户了。用过期响应覆盖会把当前客户的回显
        // 换成上一个客户，所以对不上就丢弃
        if (this.value !== idsKey) {
          return;
        }
        this.selectedItems = (res || []).map(r => ({id: r.partnerId, name: r.merchantRemarkName}));
      }).catch(() => {});
    },
    toShowDialog() {
      if (this.disabled) {
        return;
      }
      this.showDialog = true;
      if (!this.dialogList.length) {
        this.resetSearchDialog();
      }
    },
    // 对话框打开后回显已选（此时表格数据已加载）
    tableDataBack() {
      if (!this.multi || !this.$refs.selectTable) {
        return;
      }
      const ids = this.currentIds();
      if (!ids.length) {
        return;
      }
      this.$nextTick(() => {
        this.dialogList.forEach(row => {
          if (ids.includes(row.partnerId)) {
            this.$refs.selectTable.getTable().toggleRowSelection(row, true);
          }
        });
      });
    },
    clickCategory(data) {
      this.dialogSearchInfo.category = data.dictCode;
      this.resetSearchDialog();
    },
    resetSearchDialog() {
      this.dialogSearchInfo.pageNumber = 1;
      this.dialogQueryList();
    },
    dialogQueryList() {
      const query = this.queryApi || commonDataApi.queryPartnerList;
      query(this.dialogSearchInfo).then(res => {
        this.dialogList = res.records;
        this.dialogSearchInfo.totalCount = res.totalCount;
      })
    },
    dialogSelectionChange(list) {
      this.dialogSelected = list;
    },
    // 前端选中了某个数据
    selectDataFront() {
      this.isSelectData = true;
      setTimeout(() => this.isSelectData = false, 300);
    },
    // 单选选中某个客户
    selectCustomer(data) {
      this.value = data.partnerId;
      this.customerName = data.merchantRemarkName;
      this.selectedItems = [{id: data.partnerId, name: data.merchantRemarkName}];
      this.selectDataFront();
      this.$emit("update:modelValue", this.value);
      this.$emit("change", this.selectedItems.map(s => s.id));
      this.showDialog = false;

    },
    // 多选确定
    confirmMulti() {
      const rows = this.dialogSelected || [];
      if (!rows.length) {
        this.$message.error("请选择客户");
        return;
      }
      this.selectedItems = rows.map(r => ({id: r.partnerId, name: r.merchantRemarkName || ''}));
      this.selectDataFront();
      this.$emit("update:modelValue", this.selectedItems.map(s => s.id).join(','));
      this.$emit("change", this.selectedItems.map(s => s.id).join(','));
      this.showDialog = false;
    },
    // 删除单个已选客户
    removeItem(id) {
      this.selectedItems = this.selectedItems.filter(s => s.id !== id);
      const ids = this.selectedItems.map(s => s.id);
      this.selectDataFront();
      this.$emit("update:modelValue", this.multi ? ids.join(',') : (ids[0] || ''));
      this.$emit("change", ids.join(','));
    },
    clearData() {
      this.customerName = "";
      this.selectedItems = [];
      this.selectDataFront();
      this.$emit("update:modelValue", "");
      this.$emit("change", "");
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-select{
  display: inline-flex !important;
  border: none !important;
  align-items: center;
  padding: 0 10px;
  min-width: 240px;
  box-sizing: border-box;
  border-radius: var(--el-border-radius-base);
  box-shadow: 0 0 0 0.02667rem var(--el-border-color) inset;
  min-height: 36px;
  font-size: 14px;
  position: relative;
  .name{
    font-size: 14px;
    color: var(--yq-font-color-base);
    gap: 0;
    &:not(:empty):after  {
      content: ":";
      margin-right: 8px;
    }
  }
  .value{
    flex: 1;
    color: #333;
    .placeholder{
      color: #999;
    }
  }
  .select-wrap{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 2px 0;
    .select-tag{
      display: inline-flex;
      align-items: center;
      padding: 0 8px;
      height: 22px;
      margin: 2px;
      background: var(--el-color-primary-light-9, #ecf5ff);
      border: 1px solid var(--el-color-primary-light-5, #b3d8ff);
      border-radius: 4px;
      font-size: 12px;
      color: var(--el-color-primary);
      .tag-close{
        margin-left: 4px;
        cursor: pointer;
        font-size: 12px;
        &:hover{
          color: var(--el-color-danger);
        }
      }
    }
    .clear-all{
      margin-left: 6px;
      cursor: pointer;
      font-size: 14px;
      color: var(--yq-font-color-tips, #909399);
      &:hover{
        color: var(--el-color-danger);
      }
    }
  }
}
.select-wrap{
  position: relative;
  .clear-all{
    position: absolute;
    right: 0;
    display: none;
  }
  &:hover{
    .clear-all{
      display: block;
    }
  }
}
</style>
